<template>
    <CModel
            width="720px"
            v-model="visible"
            :title="title"
            :okLoading="saveLoading"
            @on-ok="save"
            @on-cancel="cancel">
        <div class="form-area">
            <Form style="width: 900px" ref="form" :model="model" :rules="rules" :label-width="110" label-position="left" inline>
                <FormItem :class="{'model-hidden': true}" label="文本框">
                    <Input v-model="model.id" type="text"></Input>
                </FormItem>
                <br>
                <FormItem label="公共平台名称" prop="platformName">
                    <Input max-length="30" v-model="model.platformName" style="width:320px" type="text"></Input>
                </FormItem>
                <br>
                <FormItem label="公共平台级别" prop="platformLevelType">
                    <RadioGroup v-model="model.platformLevelType">
                        <Radio label="1">市级</Radio>
                        <Radio label="2">区级</Radio>
                    </RadioGroup>
                </FormItem>
                <br>
                <FormItem label="公共平台图标" prop="platformIcon">
                    <upload
                            accept="image/*"
                            style="width:320px"
                            :action=uploadUrl
                            :headers="headers"
                            list-type="picture-card"
                            :limit="1"
                            :file-list="picList"
                            :on-exceed="onExceed"
                            :before-upload="beforeUpload"
                            :on-success="handlePicSuccess"
                            :on-remove="handlePicRemove">
                        <i class="el-icon-plus"></i>
                    </upload>
                    <span style="font-size:10px ; color: red">建议图片100*100</span>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </FormItem>
                <br>
                <FormItem label="公共平台地址" prop="platformUrl">
                    <Input max-length="100" v-model="model.platformUrl" style="width:320px" type="text"></Input>
                </FormItem>
            </Form>
        </div>
    </CModel>
</template>
<script>
    import util from '@/libs/util.js'
    import upload from '@/components/upload'
    import CModel from '@/components/cModel'
    export default {
        components: {upload,CModel},
        // props: ['userid'],
        data () {
            return {
                saveLoading:false,
                loading: false,
                visible: false,
                model: {platformLevelType : "1",platformLevelName:'市级',platformIcon:''},
                uploadUrl: util.baseUrl + 'api/common/upload',
                headers: { 'Authorization': localStorage.token },
                dialogImageUrl: '',
                dialogVisible: false,
                picList: [],
                title: '',
                rules: {
                    platformName: [
                        { required: true, message: '请输入公共平台名称', trigger: 'blur' },
                    ],
                    platformLevelType: [
                        { required: true, message: '请选择公共平台级别', trigger: 'blur' },
                    ],
                    platformIcon: [
                        { required: true, message: '请选择公共平台图标', trigger: 'change' },
                    ],
                    platformUrl: [
                        { required: true, message: '请输入公共平台地址', trigger: 'blur' },
                    ],
                },
                
            }
        },
        watch: {
            'model.platformLevelType' (val) {
                if (val == 1) {
                    this.model.platformLevelName = '市级'
                }
                if (val == 2) {
                    this.model.platformLevelName = '区级'
                }
            }
        },
        mounted () {
        },
        methods: {

            cancel () {
                this.model = {platformLevelType : "1",platformLevelName:'市级',platformIcon:''}
                this.picList = []
                this.$refs['form'].resetFields()
                this.visible = false
                this.saveLoading=false
            },
            //保存
            save () {
                this.$refs['form'].validate((valid) => {
                    console.log(valid)
                    if (valid) {
                        if (this.model.id) {
                            this.update()
                        } else {
                            this.create()
                        }
                    } else {
                        this.$Message.warning('请检查填写的信息');
                    }
                })
            },
            create () {
                let _this = this
                _this.saveLoading = true
                _this.$util.http
                        .post('/api/tqtPublicServicePlatforms/add', this.model, {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                        .then(function (response) {
                            _this.$Notice.success({
                                title: '保存成功!'
                            })
                            _this.cancel()
                            _this.$parent.listTable()
                        })
                        .catch(function (error) {
                            _this.$Notice.error({
                                title: '保存失败!'
                            })
                            _this.saveLoading = false
                            console.log(error)
                        })
            },

            update () {
                let _this = this
                _this.saveLoading = true
                _this.$util.http
                        .post('/api/tqtPublicServicePlatforms/update', this.model, {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                        .then(function (response) {
                            if (response) {
                                _this.$Notice.success({
                                    title: '更新成功!'
                                })
                            }
                        })
                        .catch(function (error) {
                            _this.$Notice.error({
                                title: '更新失败!'
                            })
                            _this.saveLoading = false
                            console.log(error)
                        })
                        .finally(() => {
                            _this.cancel()
                            _this.$parent.listTable()
                        })
            },
            onExceed () {
                this.$Notice.warning({
                    title: '只能上传一张图片!'
                })
            },
            beforeUpload (file) {
                const testImg = /^image\/(jpeg|png|jpg)$/.test(file.type)
                if (!testImg) {
                    this.$Notice.error({title: '上传图片只能是jpeg|png|jpg格式!'})
                    return false
                }
            },
            handlePicSuccess (response, file, fileList) {
                if (response.success) {
                    this.model.platformIcon = response.result.path || ''
                    this.picList = fileList
                }
            },
            handlePicRemove (file, fileList) {
                this.picList = []
                this.model.platformIcon = null
            },
            handlePictureCardPreview (file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            },

        }
    }
</script>
<style scoped>
    .title {
        display: flex;
        border-bottom: none;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        padding-left: 6px;
    }

    .p {
        width: 33%;
        text-align: center;
    }

    .model-hidden {
        display: none;
    }
</style>
